import ApiService from 'utils/ApiCalls';
import axios from 'axios';
import { notification } from 'antd';

const fetchAllFunctions = async () => {
  try {
    const response = await ApiService.getListOfFunctions();
    return response;
  } catch (error) {
    console.log('Error fetching all functions:', error);
  }
};

const fetchFunctionsByEntity = async (entityData: any) => {
  try {
    const response = await ApiService.postFunctionsByEntity(entityData);
    return response;
  } catch (error) {
    console.log('Error fetching functions by entity:', error);
  }
};

const fetchFunctionbyEntityName = async (entityTypeData: any) => {
  try {
    const response = await ApiService.postFunctionByEntityName(entityTypeData);
    return response;
  } catch (error) {
    console.log('Error fetching the Function:', error);
  }
};

const insertFunctions = async (functions: any) => {
  try {
    const response = await ApiService.postFunctions(functions);
    notification.success({
      message: 'Info',
      description: 'The data was successfully submitted.',
      placement: 'topRight',
      duration: 20,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

const fetchLicencedActivities = async () => {
  try {
    const response = await ApiService.getLicensedActivities();
    return response;
  } catch (error) {
    console.log('Error fetching the licenced activities:', error);
  }
};

const fetchLicencedActivitiesPerEntity = async (
  entity_id: any,
  entity_name: any,
) => {
  try {
    const response = await ApiService.postLicensedActivities(
      entity_id,
      entity_name,
    );
    return response;
  } catch (error) {
    console.log('Error fetching the licenced activities:', error);
  }
};

const fetchDataSensitiveness = async () => {
  try {
    const response = await ApiService.getDataSensitiveness();
    return response;
  } catch (error) {
    console.log('Error fetching the data sensitiveness:', error);
  }
};
const fetchFunctionLevels = async () => {
  try {
    const response = await ApiService.getFunctionLevels();
    return response;
  } catch (error) {
    console.log('Error fetching the function levels:', error);
  }
};

const fetchICTSystems = async () => {
  try {
    const response = await ApiService.getICTSystems();
    return response;
  } catch (error) {
    console.log('Error fetching the ict systems:', error);
  }
};

const fetchICTSystemsCategoryFunctionbyEntityName = async (
  entityTypeData: any,
) => {
  try {
    const response =
      await ApiService.postICTSystemsByEntityCategoryFunction(entityTypeData);
    return response;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log(
        'Error fetching ICt Systems:',
        error.response?.data || error.message,
      );
    } else {
      console.log('An unexpected error occurred:', error);
    }
    throw error;
  }
};

const updateRecoveryObjective = async (objectives: any) => {
  try {
    const response = await ApiService.updateRecoveryObjective(objectives);
    return response;
  } catch (error) {
    console.log(error);
  }
};

const fetchFunctionsCriticality = async () => {
  try {
    const response = await ApiService.getFunctionsCriticality();
    return response;
  } catch (error) {
    console.log('Error fetching the function criticality', error);
  }
};

const fetchImpactOfDiscontinuingFunctions = async (entity_id: any) => {
  try {
    const response =
      await ApiService.getImpactOfDiscontinuingFunctions(entity_id);
    return response;
  } catch (error) {
    console.log('Error fetching the impact of discontinuing Functions', error);
  }
};

export default {
  fetchAllFunctions,
  fetchFunctionbyEntityName,
  fetchFunctionsByEntity,
  insertFunctions,
  fetchLicencedActivities,
  fetchDataSensitiveness,
  fetchFunctionLevels,
  fetchICTSystems,
  updateRecoveryObjective,
  fetchFunctionsCriticality,
  fetchLicencedActivitiesPerEntity,
  fetchICTSystemsCategoryFunctionbyEntityName,
  fetchImpactOfDiscontinuingFunctions,
};
